<template>
<div class="list-item-grid">
  <transition-group mode="out-in" tag="div" name="fade">
    <Spinner v-if="status === 'loading'" key="spinner" />
    <slot v-else></slot>
  </transition-group>
</div>
</template>

<script>
import Spinner from '../Spinner/Spinner';

export default {
  name: 'ListItemGrid',
  props: {
    status: {
      type: String
    }
  },
  components: {
    Spinner,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.list-item-grid {
  max-width: $max-width;
  margin-left: auto;
  margin-right: auto;
  /* background-color: papayawhip; */
  display: flex;
  justify-content: center;
}

.list-item-grid > div {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
  /* flex: 1; */
  /* background-color: peru; */
  justify-content: flex-start;
}

.list-item-grid > p {
  text-align: center;
}
</style>
